import type { HailReportTypeRules } from '@xweather/protect-types'
import { compact } from 'es-toolkit'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CoverageZonesLayer } from '../../CoverageZonesLayer.tsx'

export const HailCoverageLayer = ({ rules }: { rules: HailReportTypeRules }) => {
	const { t } = useTranslation()
	const geometries = useMemo(() => compact(Object.values(rules.coverageZones).map(({ geometry }) => geometry)), [rules])

	return <CoverageZonesLayer geometries={geometries} label={t(($) => $.reports.hail.form.hailCoverageBoundary)} />
}
